'use strict';
import * as $i_$0040ui5$002fwebcomponents$002fdist$002fDatePicker$002ejs from "@ui5/webcomponents/dist/DatePicker.js";
import * as $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024 from "./com.raquo.laminar.-Dom-Api$.js";
import * as $j_com$002eraquo$002elaminar$002ecodecs$002epackage$0024 from "./com.raquo.laminar.codecs.package$.js";
import * as $j_io$002egithub$002enguyenyou$002eui5$002ewebcomponents$002elaminar$002eshared$002e$002dWeb$002dComponent from "./io.github.nguyenyou.ui5.webcomponents.laminar.shared.-Web-Component.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_DatePicker$() {
  this.dz = null;
  this.cu = null;
  this.dV = null;
  this.dW = false;
  this.HV = null;
  this.HW = false;
  $j_io$002egithub$002enguyenyou$002eui5$002ewebcomponents$002elaminar$002eshared$002e$002dWeb$002dComponent.$ct_Lio_github_nguyenyou_ui5_webcomponents_laminar_shared_WebComponent__T__(this, "ui5-date-picker");
}
export { $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_DatePicker$ as $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_DatePicker$ };
$p = $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_DatePicker$.prototype = new $j_io$002egithub$002enguyenyou$002eui5$002ewebcomponents$002elaminar$002eshared$002e$002dWeb$002dComponent.$h_Lio_github_nguyenyou_ui5_webcomponents_laminar_shared_WebComponent();
$p.constructor = $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_DatePicker$;
/** @constructor */
function $h_Lio_github_nguyenyou_ui5_webcomponents_laminar_DatePicker$() {
}
export { $h_Lio_github_nguyenyou_ui5_webcomponents_laminar_DatePicker$ as $h_Lio_github_nguyenyou_ui5_webcomponents_laminar_DatePicker$ };
$h_Lio_github_nguyenyou_ui5_webcomponents_laminar_DatePicker$.prototype = $p;
$p.Bv = (function() {
  if ((!this.HW)) {
    this.HV = ($j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_api_package$(), $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$ct_Lcom_raquo_laminar_keys_HtmlAttr__T__Lcom_raquo_laminar_codecs_Codec__(new $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$c_Lcom_raquo_laminar_keys_HtmlAttr(), "format-pattern", $j_com$002eraquo$002elaminar$002ecodecs$002epackage$0024.$m_Lcom_raquo_laminar_codecs_package$().ci));
    this.HW = true;
  }
  return this.HV;
});
$p.cQ = (function() {
  return $i_$0040ui5$002fwebcomponents$002fdist$002fDatePicker$002ejs.default;
});
var $d_Lio_github_nguyenyou_ui5_webcomponents_laminar_DatePicker$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lio_github_nguyenyou_ui5_webcomponents_laminar_DatePicker$, "io.github.nguyenyou.ui5.webcomponents.laminar.DatePicker$", ({
  jB: 1,
  ac: 1
}));
export { $d_Lio_github_nguyenyou_ui5_webcomponents_laminar_DatePicker$ as $d_Lio_github_nguyenyou_ui5_webcomponents_laminar_DatePicker$ };
var $n_Lio_github_nguyenyou_ui5_webcomponents_laminar_DatePicker$;
function $m_Lio_github_nguyenyou_ui5_webcomponents_laminar_DatePicker$() {
  if ((!$n_Lio_github_nguyenyou_ui5_webcomponents_laminar_DatePicker$)) {
    $n_Lio_github_nguyenyou_ui5_webcomponents_laminar_DatePicker$ = new $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_DatePicker$();
  }
  return $n_Lio_github_nguyenyou_ui5_webcomponents_laminar_DatePicker$;
}
export { $m_Lio_github_nguyenyou_ui5_webcomponents_laminar_DatePicker$ as $m_Lio_github_nguyenyou_ui5_webcomponents_laminar_DatePicker$ };
